import React, { createContext, useContext } from "react";

export type PartnerTabPermissionContextValue = {
  readOnly: boolean;
  permissionKey: string;
};

const PartnerTabPermissionContext =
  createContext<PartnerTabPermissionContextValue>({
    readOnly: false,
    permissionKey: "",
  });

export const PartnerTabPermissionProvider: React.FC<{
  value: PartnerTabPermissionContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <PartnerTabPermissionContext.Provider value={value}>
    {children}
  </PartnerTabPermissionContext.Provider>
);

export function usePartnerTabPermission(): PartnerTabPermissionContextValue {
  return useContext(PartnerTabPermissionContext);
}
